import { render } from "./etRadioSex.vue?vue&type=template&id=b326c008"
import script from "./etRadioSex.vue?vue&type=script&lang=js"
export * from "./etRadioSex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__